var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "header-container" },
      [
        _vm.popEdit
          ? _c("div", { staticClass: "pop_title" }, [
              _vm._v("Free Shipping on All Orders\n      ")
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("head-com", {
          ref: "head",
          attrs: {
            isFirstOrder: _vm.isFirstOrder,
            "is-show-nt": _vm.isShowNtInfo
          },
          on: { getList: _vm.getListHandle, wapShow: _vm.wapShow }
        }),
        _vm._v(" "),
        _c("nav-com", {
          ref: "meau",
          attrs: {
            isFirstOrder: _vm.isFirstOrder,
            "is-show-nt": _vm.isShowNtInfo
          },
          on: {
            showLoginUp: _vm.showLoginUp,
            loginHandle: _vm.loginHandle,
            showLogin: _vm.showLogin,
            showLoginHandle: _vm.showLoginHandle
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f554bd8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f554bd8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/floatHeader.vue
// module id = null
// module chunks = 